"use strict";

exports["default"] = function (obj, defaults) {
  var newObj = defaults({}, obj);
  delete newObj["default"];
  return newObj;
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-types/~/babel-runtime/helpers/interop-export-wildcard.js
 ** module id = 98
 ** module chunks = 0
 **/